// extracted by mini-css-extract-plugin
module.exports = {"productsContainer":"user-products-panel_productsContainer__3Z2gw"};